import React, { createContext, useMemo } from 'react';

import { ExpressionMetadataModel } from '../api/api';
import ExpressionVariableScopeCalculatorService from '../views/FlowDesigner/Services/ExpressionVariableScopeCalculatorService';

export interface IExpressionMetadataContext {
	expressionByName: Map<string, ExpressionMetadataModel>;
	expressions: ExpressionMetadataModel[];
	expressionScopeCalculator: ExpressionVariableScopeCalculatorService | null;
}

const emptyExpressionMetadataContext: IExpressionMetadataContext = {
	expressionByName: new Map<string, ExpressionMetadataModel>(),
	expressions: [],
	expressionScopeCalculator: null,
};

export const ExpressionMetadataContext = createContext<IExpressionMetadataContext>(emptyExpressionMetadataContext);

export function useExpressionMetadata(): IExpressionMetadataContext {
	return React.useContext(ExpressionMetadataContext);
}

interface ExpressionMetadataProviderProps {
	expressions: ExpressionMetadataModel[] | undefined;
	expressionScopeCalculator?: ExpressionVariableScopeCalculatorService | null;
	children: React.ReactNode;
}

export function ExpressionMetadataProvider({ expressions, expressionScopeCalculator = null, children }: ExpressionMetadataProviderProps) {
	const value = useMemo<IExpressionMetadataContext>(() => {
		if (!expressions) return emptyExpressionMetadataContext;

		const expressionByName = expressions.reduce((acc, expression) => {
			acc.set(expression.name, expression);
			return acc;
		}, new Map<string, ExpressionMetadataModel>());

		return { expressionByName, expressions, expressionScopeCalculator };
	}, [expressions, expressionScopeCalculator]);

	return <ExpressionMetadataContext.Provider value={value}>{children}</ExpressionMetadataContext.Provider>;
}
